/* ============================================================
   pdp-trust modal behaviour
   Loaded with defer — runs after HTML parse, before DOMContentLoaded.
   ============================================================ */

(function() {
  'use strict';

  var triggers = document.querySelectorAll('[data-pdp-trust]');
  var modal = document.querySelector('[data-pdp-modal]');
  if (!modal || triggers.length === 0) return;

  // Portal: Modal an den body anhängen, damit es jedem Parent-
  // Stacking-Context (sticky Header, transform-Container etc.)
  // entkommt und sein z-index global gilt.
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var panel = modal.querySelector('.pdp-trust-modal__panel');
  var contents = modal.querySelectorAll('.pdp-trust-modal__content');
  var closers = modal.querySelectorAll('[data-pdp-modal-close]');

  function openModal(id) {
    var found = false;
    contents.forEach(function(c) {
      var match = c.dataset.modalId === id;
      c.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;

    modal.removeAttribute('hidden');
    requestAnimationFrame(function() {
      modal.classList.add('is-open');
    });
    document.body.classList.add('pdp-modal-open');
    setTimeout(function() { panel.focus(); }, 100);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('pdp-modal-open');
    setTimeout(function() {
      modal.setAttribute('hidden', '');
    }, 300);
  }

  triggers.forEach(function(t) {
    t.addEventListener('click', function() {
      openModal(t.dataset.pdpTrust);
    });
  });

  closers.forEach(function(c) {
    c.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

/* ============================================================
   Sticky-ATC-Bar Smooth-Scroll Fix (Event-Delegation)
   Klick auf Link in der Sticky-Bar wird hier abgefangen und
   explizit zum Buy-Form gescrollt — robuster als Browser-Anchor.
   ============================================================ */
document.addEventListener('click', function(e) {
  var link = e.target.closest('sticky-atc-panel a[href^="#"], .sticky-atc-panel a[href^="#"]');
  if (!link) return;

  var target = document.querySelector('product-form')
            || document.querySelector('.product-options')
            || document.querySelector('.product-info');
  if (!target) return;

  e.preventDefault();

  var header = document.querySelector('store-header[data-is-sticky="true"]')
            || document.querySelector('.header');
  var offset = header ? header.offsetHeight + 16 : 80;

  window.scrollTo({
    top: target.getBoundingClientRect().top + window.scrollY - offset,
    behavior: 'smooth'
  });
});

